import type { PaperProps } from '@mui/material'
import { mergeSx } from 'lib/helpers/mergeSx/mergeSx'
import * as tkn from '../../Modal.tokens'
import { MODAL_SIZES, FILL_WIDTH, FILL_GUTTER } from '../../Modal.styled'
import type { ModalSize, ModalPlacement } from '../../Modal.types'

interface UsePaperSlotPropsParams {
  size?: ModalSize
  fullScreen?: boolean
  placement?: ModalPlacement
  slotProps?: PaperProps
}

export const usePaperSlotProps = ({ size, fullScreen, placement, slotProps }: UsePaperSlotPropsParams): PaperProps => {
  const width = size && MODAL_SIZES[size]
  const isFill = width === FILL_WIDTH

  return {
    ...slotProps,
    sx: mergeSx(
      {
        '&&': {
          ...(!fullScreen && {
            width,
            // Below its own width every modal collapses onto the same 8px gutter instead of MUI's
            // 32px margin, so a narrow viewport never leaves a wider size rendering narrower.
            maxWidth: FILL_WIDTH,
            marginLeft: FILL_GUTTER,
            marginRight: FILL_GUTTER,
            ...(isFill && { marginTop: FILL_GUTTER, marginBottom: FILL_GUTTER }),
          }),
          ...(fullScreen && {
            margin: '8px',
            maxHeight: 'calc(100% - 16px)',
          }),
          background: tkn.ModalColorSurface,
          borderRadius: tkn.ModalBorderRadiusContainer,
          ...(placement === 'top' && {
            alignSelf: 'flex-start',
          }),
        },
        '@media (max-height:700px)': {
          marginTop: '8px',
          marginBottom: '8px',
          maxHeight: 'calc(100% - 16px)',
        },
      },
      slotProps?.sx,
    ),
  }
}
